import { InputWrap, MyStyledInput, MyError } from './styles';
import { Field, FieldProps } from 'formik';

export interface InputProps {
	nameData: string;
	placeholderData?: string;
	typeData: string;
	label?: string;
	isDisabled?: boolean;
	maxlength?: number;
	quitErrorData?: boolean;
	// eslint-disable-next-line no-unused-vars
	onBlur?: (e: any) => void;
}

const Input = (props: InputProps) => {
	const {
		nameData,
		placeholderData,
		typeData,
		label,
		isDisabled,
		maxlength,
		onBlur: customOnBlur,
	} = props;
	return (
		<>
			<Field name={nameData}>
				{({ field, meta }: FieldProps) => (
					<InputWrap>
						{label && <label>{label}</label>}
						<MyStyledInput
							type={typeData}
							placeholder={placeholderData}
							className={meta.touched && meta.error ? 'error' : ''}
							disabled={isDisabled}
							maxLength={maxlength}
							{...field}
							onBlur={(e: any) => {
								// A. Ejecutamos SIEMPRE la lógica de Formik (marcar como touched)
								field.onBlur(e);
								// B. Si el padre mandó una función onBlur, la ejecutamos también
								if (customOnBlur) {
									customOnBlur(e);
								}
							}}
						/>
						{meta.touched && meta.error && !isDisabled && <MyError>{meta.error}</MyError>}
					</InputWrap>
				)}
			</Field>
		</>
	);
};

export default Input;
